<template>
  <div class="flex items-center justify-content-center">
    <input id="start_value" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-3 mr-4 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" type="text" v-model="startValue" placeholder="Desde">
    <input id="end_value" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-3 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" type="text" v-model="endValue" placeholder="Hasta">
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: 'ValueRangePickerComponent',
  props: ['customNumberFormat'],
  setup(props, {emit}) {
    const startValue = ref('');
    const endValue = ref('');

    watch([startValue, endValue], function([newStartValue, newEndValue]) {
      startValue.value = props.customNumberFormat ? props.customNumberFormat(newStartValue) : newStartValue;
      endValue.value = props.customNumberFormat ? props.customNumberFormat(newEndValue) : newEndValue;
      emit('valueRangePicker', {startValue: Number(startValue.value.replaceAll(',', '')), endValue: Number(endValue.value.replaceAll(',', ''))});
    });

    return {
      startValue,
      endValue,
    }
  }
}
</script>